import {useState, useEffect} from 'react';
import { projectURL } from './utils/mockdata';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);


const Chart = () => {
    const [mxPost, setMxPost] = useState([]);

    const maxPostCreator = async () => {
        const postPath = projectURL + "dashboard/max-post-creator";
        const postList = await fetch(postPath,{
            headers:{"cors":"no-cors"}
        });
        const postJson = await postList.json();    
        setMxPost(postJson);
    }

    useEffect(() => {
        maxPostCreator();
    }, []);
    
    const maxPostDataName = mxPost.map((data) => ({
        name: data.username
    })).map((data) => data.name);

    const maxPostDataCount = mxPost.map((data) => ({
       count: data.postCount
    })).map((data) => data.count);


    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'User Posts (Bar Chart)',
            },
        },
    };

    const data = {
        labels:  maxPostDataName,//['January', 'February', 'March', 'April', 'May', 'June'],
        datasets: [
            {
            label: 'Posts',
            data: maxPostDataCount,//[50, 60, 70, 180, 90, 20],
            backgroundColor: [
            'rgb(255, 99, 132)', 'rgb(54, 162, 235)', 'rgb(255, 205, 86)',
            'rgb(75, 192, 192)', 'rgb(153, 102, 255)', 'rgb(255, 159, 64)',
            'rgb(201, 203, 207)', 'rgb(255, 99, 71)', 'rgb(100, 149, 237)',
            'rgb(60, 179, 113)', 'rgb(255, 215, 0)', 'rgb(219, 112, 147)',
            'rgb(0, 191, 255)', 'rgb(138, 43, 226)', 'rgb(106, 90, 205)',
            'rgb(46, 139, 87)', 'rgb(255, 140, 0)', 'rgb(127, 255, 0)',
            'rgb(176, 196, 222)', 'rgb(255, 20, 147)', 'rgb(64, 224, 208)',
            'rgb(123, 104, 238)', 'rgb(240, 128, 128)', 'rgb(72, 209, 204)',
            'rgb(255, 160, 122)', 'rgb(218, 112, 214)', 'rgb(144, 238, 144)',
            'rgb(210, 105, 30)', 'rgb(135, 206, 250)', 'rgb(244, 164, 96)',
            'rgb(221, 160, 221)', 'rgb(152, 251, 152)', 'rgb(0, 206, 209)',
            'rgb(186, 85, 211)', 'rgb(175, 238, 238)', 'rgb(255, 228, 181)',
            'rgb(60, 179, 113)', 'rgb(233, 150, 122)', 'rgb(147, 112, 219)',
            'rgb(32, 178, 170)', 'rgb(255, 182, 193)', 'rgb(95, 158, 160)',
            'rgb(255, 105, 180)', 'rgb(72, 61, 139)', 'rgb(173, 255, 47)',
            'rgb(205, 92, 92)', 'rgb(199, 21, 133)', 'rgb(176, 224, 230)',
            'rgb(245, 222, 179)', 'rgb(100, 149, 237)'
            ],
            },
        ],
    };

  return <Bar options={options} data={data} />;
}

export default Chart;